import { DirectUpload } from "@rails/activestorage"

export class ImageUploadHelper {
    static compressImage(file, callback, options = {}) {
        const MAX_WIDTH = options.maxWidth || 2048;
        const MAX_HEIGHT = options.maxHeight || 2048;
        const MIME_TYPE = options.mimeType || "image/jpeg";
        const QUALITY = options.quality || 0.7;
        const originalFileName = file.name;

        const blobURL = URL.createObjectURL(file);
        const img = new Image();
        img.src = blobURL;

        img.onerror = () => {
            URL.revokeObjectURL(img.src);
            console.error("Cannot load image for compression.");
            callback(new Error("Cannot load image for compression."), null);
        };

        img.onload = () => {
            URL.revokeObjectURL(img.src);
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        callback(null, blob, originalFileName);
                    } else {
                        console.error("Failed to create blob for image compression.");
                        callback(new Error("Failed to create blob for image compression."), null);
                    }
                },
                MIME_TYPE,
                QUALITY
            );
        };
    }

    static uploadImage(imageBlob, originalFileName, directUploadUrl, callback) {
        const fileToUpload = new File([imageBlob], originalFileName, { type: imageBlob.type });
        const uploader = new DirectUpload(fileToUpload, directUploadUrl);

        uploader.create((error, blobData) => {
            if (error) {
                console.error("Direct upload failed:", error);
                callback(error, null);
            } else {
                callback(null, blobData.signed_id);
            }
        });
    }

    static getCsrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    }

    static getCsrfParam() {
        return document.querySelector('meta[name="csrf-param"]')?.getAttribute('content') || 'authenticity_token';
    }
} 